/* Style by Ayesha - Video Hero Banner
   Minimal JS: picks the correct video for the breakpoint, respects
   prefers-reduced-motion, and pauses offscreen video for performance.
   Does not modify any existing theme JS. */
(function () {
  'use strict';

  function initVideoHero(section) {
    var desktopVideo = section.querySelector('.video-hero__video--desktop');
    var mobileVideo = section.querySelector('.video-hero__video--mobile');
    var videos = [desktopVideo, mobileVideo].filter(Boolean);

    if (!videos.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      videos.forEach(function (video) {
        video.pause();
        video.removeAttribute('autoplay');
      });
      return;
    }

    var mql = window.matchMedia('(min-width: 750px)');

    function activeVideo() {
      return mql.matches ? desktopVideo : mobileVideo;
    }

    function playActive() {
      var active = activeVideo();
      videos.forEach(function (video) {
        if (!video) return;
        if (video === active) {
          if (video.preload !== 'auto') video.preload = 'auto';
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        } else {
          video.pause();
        }
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              playActive();
            } else {
              videos.forEach(function (video) {
                if (video) video.pause();
              });
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(section);
    } else {
      playActive();
    }

    var resizeTimer;
    function handleBreakpointChange() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(playActive, 150);
    }

    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', handleBreakpointChange);
    } else if (typeof mql.addListener === 'function') {
      mql.addListener(handleBreakpointChange);
    }
  }

  function init() {
    document.querySelectorAll('[data-video-hero]').forEach(initVideoHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-video-hero]');
    if (section) initVideoHero(section);
  });
})();
